/** 名入れ、ロゴの刻印の種類 */
export enum PrintType {
  Embossing = 'st',
  GoldPressing = 'gl',
  SilverPressing = 'sv'
}

export default PrintType

export function fromString(str: string): PrintType | null {
  switch (str) {
    case PrintType.Embossing:
    case PrintType.GoldPressing:
    case PrintType.SilverPressing:
      return str
    default:
      return null
  }
}

/** 刻印可能な印刷方法 */
export interface PossiblePrintType {
  printType: 'stamp' | 'gold_emboss' | 'silver_emboss'
}

export function possiblePrintTypeToPrintType(t: PossiblePrintType): PrintType {
  switch (t.printType) {
    case 'stamp':
      return PrintType.Embossing
    case 'gold_emboss':
      return PrintType.GoldPressing
    case 'silver_emboss':
      return PrintType.SilverPressing
  }
}

export function printTypeToPossiblePrintType(t: PrintType): PossiblePrintType {
  switch (t) {
    case PrintType.Embossing:
      return { printType: 'stamp' }
    case PrintType.GoldPressing:
      return { printType: 'gold_emboss' }
    case PrintType.SilverPressing:
      return { printType: 'silver_emboss' }
  }
}

// Note: 表示用の定数は未使用のため削除しました
